module.exports = __webpack_public_path__ + "static/media/S_10.0aa78cf1.png";